import { useState } from 'react';
import type { Editor } from '@tiptap/core';
import { ToggleButton } from '@mui/material';

import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';

import { AnchorDialog } from './anchor-button/AnchorDialog';
import type { RootOwner } from './anchor-button/file-selector/FileSelectorDialog';

interface Props {
  editor: Editor;
  rootOwner?: RootOwner;
  disableFileSelector: boolean;
}

export const AnchorButton = ({
  editor,
  disableFileSelector,
  rootOwner,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <ToggleButton
        value="anchor"
        selected={false}
        onClick={() => setDialogOpen(true)}
      >
        <InsertLinkOutlinedIcon />
      </ToggleButton>
      <AnchorDialog
        rootOwner={rootOwner}
        open={dialogOpen}
        editor={editor}
        onClose={() => setDialogOpen(false)}
        disableFileSelector={disableFileSelector}
      />
    </>
  );
};
